import { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Imports => Utilities
import { AcIsSet, AcIsArray } from '@opp/ui-kit';

// Imports => Atoms
import AcSpecificationRowListItem from '@atoms/ac-specification-row-list-item/ac-specification-row-list-item';

const _CLASSES = {
  MAIN: 'ac-specification-row-list',
  CONTAINER: 'ac-specification-row-list__container',
};

const AcSpecificationRowList = ({ items = [], className }) => {
  const getContainerClassNames = useMemo(() => {
    return clsx(_CLASSES.CONTAINER);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, className);
  }, [className]);

  const renderItems = useMemo(() => {
    if (!AcIsSet(items) || !AcIsArray(items)) return null;

    const collection = items;
    const len = collection.length;
    let n = 0;
    let result = [];

    for (n; n < len; n++) {
      const item = collection[n];

      const object = (
        <AcSpecificationRowListItem
          key={`ac-specification-row-list-item-${item.reference}`}
          data={item}
        />
      );

      result.push(object);
    }

    return result;
  }, [items]);

  return (
    <div className={getMainClassNames}>
      <div className={getContainerClassNames}>{renderItems}</div>
    </div>
  );
};

AcSpecificationRowList.propTypes = {
  /**
     * For CSS customization
     */
  className: PropTypes.string,
};

export default memo(AcSpecificationRowList);
